export default __webpack_public_path__ + "static/media/loading.8401b3e6.gif";